import cfg, {
  msgDirectionClientToUser, msgDirectionSystemToUser,
  SOCKETS_CONNECTING,
  SOCKETS_ERR,
  TYPE_MSG_EDIT_MESSAGE,
  TYPE_MSG_NEW_CHAT,
  TYPE_MSG_NEW_MESSAGE,
  TYPE_MSG_NEW_REMIND,
  TYPE_MSG_PING,
  UPDATE_CHAT_ALERT,
  UPDATE_CHAT_CHANGED_MESSAGE,
  UPDATE_CHAT_ITEM_NEW,
  UPDATE_CHAT_NEW_MESSAGE,
  UPDATE_CHAT_REMINDER_NEW,
  TYPE_MSG_CURATOR_CHANGED,
  TYPE_MSG_MESSAGES_ANSWERED,
  UPDATE_CHAT_UNANSWERED,
  UPDATE_PAGE,
  TYPE_MSG_GET_CHAT_MEMBER,
  UPDATE_CHAT_CLIENT_UNBAN_CHAT_MEMBER,
} from '../constants';
import {v4 as uuidv4} from 'uuid'

export function socketsConnecting(conn, token) {
  return (dispatch) => {
    if (window["WebSocket"]) {
      if (conn !== null) {
        conn.close(1000);
      }

      if (token === "") {
        return;
      }
      const newconn = new WebSocket(cfg.socket_url + "?jwt_code=" + token + "&id_front_client=" + uuidv4());
      newconn.onclose = (evt) => {
        console.log('WebSocket close', evt);
        dispatch({type: SOCKETS_CONNECTING, conn: null});
      };

      newconn.onmessage = (evt) => {
        var messages = evt.data.split('\n');
        for (let i = 0; i < messages.length; i++) {
          let json_msg = JSON.parse(messages[i]);
          const data = json_msg.body ? JSON.parse(json_msg.body) : {};
          switch (json_msg.type) {
            case TYPE_MSG_PING:
              // console.log(json_msg)
              break;
            case TYPE_MSG_NEW_MESSAGE:
              dispatch({type: UPDATE_CHAT_NEW_MESSAGE, message: data});
              if (data.message_direction === msgDirectionClientToUser || data.message_direction === msgDirectionSystemToUser) {
                dispatch({type: UPDATE_CHAT_ALERT, alert: {chat_id: data.chat_id, id: data.id, read_status: data.read_status}});
              }
              break;
            case TYPE_MSG_EDIT_MESSAGE:
              dispatch({type: UPDATE_CHAT_CHANGED_MESSAGE, message: data});
              break;
            case TYPE_MSG_NEW_CHAT:
              dispatch({type: UPDATE_CHAT_ITEM_NEW, item: data});
              dispatch({type: UPDATE_CHAT_ALERT, alert: {chat_id: data.chat_id, id: data.last_messages.id, read_status: data.last_messages.read_status}});
              break;
            case TYPE_MSG_NEW_REMIND:
              dispatch({type: UPDATE_CHAT_REMINDER_NEW, item: data});
              break;
            case TYPE_MSG_CURATOR_CHANGED:
              dispatch({type: UPDATE_PAGE, item: data});
              break;
            case TYPE_MSG_MESSAGES_ANSWERED:
              dispatch({type: UPDATE_CHAT_UNANSWERED, id: data.id});
              //dispatch({type: UPDATE_PAGE, item: data});
                break;
            case TYPE_MSG_GET_CHAT_MEMBER:
              //dispatch({type: UPDATE_PAGE, item: data});
              dispatch({type: UPDATE_CHAT_CLIENT_UNBAN_CHAT_MEMBER, block_in_chat_boltalok_id_list: data});
              break;
            default:
              break;

          }
        }
      };
      dispatch({type: SOCKETS_CONNECTING, conn: newconn});
    } else {
      dispatch({type: SOCKETS_ERR,  error: {msg: "WebSocket is not supported"}});
    }
  }
}
